import { getObjectKeysAsObject } from "@checkout/helpers";
import { completeInteractiveFulfillService } from "./completeInteractiveFulfill";
import { pollInteractivePaymentAuthService } from "./pollInteractivePaymentAuth";

export const Services = {
  pollInteractivePaymentAuthService,
  completeInteractiveFulfillService,
};

export const ServiceTypes = getObjectKeysAsObject(Services);
